import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { CityProvider } from "@/context/CityContext";
import { CustomerProvider } from "@/context/CustomerContext";
import Layout from "@/components/Layout";
import AccessGate from "@/components/AccessGate";
import Home from "@/pages/Home";
import Vendors from "@/pages/Vendors";
import Packages from "@/pages/Packages";
import OccasionsIndex from "@/pages/OccasionsIndex";
import OccasionBuilder from "@/pages/OccasionBuilder";
import Decorations from "@/pages/Decorations";
import VendorDetail from "@/pages/VendorDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AIPlanner from "@/pages/AIPlanner";
import BecomeVendor from "@/pages/BecomeVendor";
import Careers from "@/pages/Careers";
import OrderHistory from "@/pages/OrderHistory";
import ByService from "@/pages/ByService";
import Halls from "@/pages/Halls";
import HallDetail from "@/pages/HallDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import VendorLogin from "@/pages/VendorLogin";
import VendorDashboard from "@/pages/VendorDashboard";
import CustomerLogin from "@/pages/CustomerLogin";
import CustomerRegister from "@/pages/CustomerRegister";
import CustomerDashboard from "@/pages/CustomerDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <CityProvider>
          <CustomerProvider>
          <CartProvider>
            <AccessGate>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/vendors" element={<Vendors />} />
                <Route path="/packages" element={<Packages />} />
                <Route path="/occasions" element={<OccasionsIndex />} />
                <Route path="/occasions/:slug" element={<OccasionBuilder />} />
                <Route path="/decorations" element={<Decorations />} />
                <Route path="/services" element={<ByService />} />
                <Route path="/halls" element={<Halls />} />
                <Route path="/halls/:id" element={<HallDetail />} />
                <Route path="/vendors/:id" element={<VendorDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/ai-planner" element={<AIPlanner />} />
                <Route path="/become-vendor" element={<BecomeVendor />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/orders" element={<OrderHistory />} />
                <Route path="/login" element={<CustomerLogin />} />
                <Route path="/register" element={<CustomerRegister />} />
                <Route path="/account" element={<CustomerDashboard />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/vendor/login" element={<VendorLogin />} />
              <Route path="/vendor" element={<VendorDashboard />} />
            </Routes>
            </AccessGate>
          </CartProvider>
          </CustomerProvider>
        </CityProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
